import React from 'react';

import { Cars } from './SearchModels';
import ProductCard from '../ProductCard';
import { Item } from '../../StyledComponents/Grid';
import { toProductCard } from '../ProductCard/utils';

interface CarsItemProps {
  data: Cars;
  displayBranchName: boolean;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>, id: string, slug: string) => void;
}

const CarsItem = ({ data, displayBranchName, onClick }: CarsItemProps) => (
  <Item>
    <ProductCard href={`/sok/id/`} onClick={onClick} {...toProductCard(data, displayBranchName)} />
  </Item>
);

export default CarsItem;
